module.exports = __webpack_public_path__ + "static/media/icon-no-data-found.05d943e8.svg";